import React,{useEffect, useState, Component, Fragment } from "react";
// import Paper from '@mui/material/Paper';
// import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import TableCell from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
// import TablePagination from '@mui/material/TablePagination';
// import TableRow from '@mui/material/TableRow';
// import useVendor from './vendor-data-fetch/vendor-data';
import { useNavigate } from 'react-router-dom';

// import toast from "react-toastify";
import format from 'date-fns/format';
import DateRangeSelector from '../../Ui-Elemnent/DateRange'
import { DropDown } from '../../Ui-Elemnent/DropDown'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import Table from './CityWise/CityClustureTable';
import Table from "./TspDataSheet"

export default function Tsp({city, range, setRange}:{city:string, range:any, setRange:any}) {

  // Pagiation
  const [totalCount, setTotalCount] = useState<number>(0)
  const [skip, setSkip] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);
  const [currentPage, setCurrentPage] = useState<number>(1)

  useEffect(()=>{
    setSkip((currentPage -1) * limit)
    
  },[currentPage, limit ])

  const clickPrevious = ()=>{
  currentPage !== 1 ?  setCurrentPage(currentPage - 1) :setCurrentPage(1)
  }
  const clickNext = ()=>{
     setCurrentPage(currentPage + 1) 
    }
  // DateRange
  const [dayDiff, setDaydiff] =useState<any>();
  const today = new Date();
  const [toDate, setToDate] = useState<string>(format(new Date(), "yyyy-MM-dd"));
  const [fromDate, setFormDate] = useState<string>(format(new Date(), "yyyy-MM-dd"));
  const [filtered, setfiltered] =useState<any>();
  const navigate = useNavigate();
  // const { vendorsDetails } = useVendor()
  const vendorsDetails :any= [];
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };


  useEffect(()=>{

    setToDate(format(range[0].endDate, "yyyy-MM-dd"))
    setFormDate(format(range[0].startDate, "yyyy-MM-dd"))

    setDaydiff((range[0].endDate - range[0].startDate) / 86400000);

  },[range, toDate, fromDate]);

  // let { filtered } = this.state;
    let pageSize = filtered ? filtered.length : 10;
    // console.log(this.state);
    // const { cityName } = this.props;
  
  return (
    <div className=''>
      <div className='w-full ml-2 mt-8 h-1/2'>
          <div className=''>
            <div>
                <Table city={city}  skip={skip} limit={limit} setTotalCount={setTotalCount} range={range} setRange={setRange}/>
            </div>
        </div>
      </div>

      <div className='flex justify-start w-1/2 items-end mt-2 mx-8'>
          <button className={`border rounded bg-lightBlue hover:bg-recity hover:text-white p-2 disabled:opacity-25 mr-2 `} onClick={clickPrevious} disabled={currentPage === 1 ? true : false} >Previous</button>
          <button type='button' className={`border rounded bg-lightBlue hover:bg-recity hover:text-white p-2 disabled:opacity-25`} onClick={clickNext} disabled={(currentPage * limit) >  totalCount ? true: false}>Next</button>
          <div className='mx-5'>{`Showing ${skip + 1 > totalCount ? totalCount :  skip + 1 } to ${ currentPage * limit >  totalCount ? totalCount :currentPage * limit} out of ${totalCount} data`}</div>
          <DropDown list={[10,20,50]} selected={`${limit} entries per row`} setSelected={setLimit}/>
      </div>
    </div>
  )
}

// export default Tsp